export default function Logo({ size = 36, className = "" }) {
  return (
    <img src="/logo.png" width={size} height={size} alt="Guatemalan Spirits — due alici di Cetara e la bottiglia" className={`shrink-0 rounded-full ${className}`} data-testid="brand-logo" />
  );
}
